module.exports = __webpack_public_path__ + "odinstatic/media/third-party.b1d223cb.svg";